import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ContentModule} from '../../../../shared/directives/content.module';
import {ContentModalModule} from '../../../../shared/directives/content-modal.module';
import {ChipsAutocompleteComponent} from './chips-autocomplete.component';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatChipsModule} from '@angular/material/chips';
import {AsyncPipe, CommonModule} from '@angular/common';
import {MatIconModule} from '@angular/material/icon';
import {LoadingModule} from '../../../../components/common/loading/loading.module';
import {ErrorTextModule} from '../error-text/error-text.module';
import {KeepHtmlPipeModule} from "../../pipe/keep-html.pipe";
import {MatLegacyChipsModule} from '@angular/material/legacy-chips';

@NgModule({
    declarations: [
        ChipsAutocompleteComponent,
    ],
    exports: [
        ChipsAutocompleteComponent,
        ContentModule,
        ContentModalModule,
    ],
    imports: [
        ReactiveFormsModule,
        CommonModule,
        FormsModule,
        MatFormFieldModule,
        MatAutocompleteModule,
        MatChipsModule,
        MatIconModule,
        LoadingModule,
        ErrorTextModule,
        KeepHtmlPipeModule,
        MatLegacyChipsModule,
    ]
})
export class ChipsAutocompleteModule {
}
